<div class="header">
  <div class="title">
    Filters <span *ngIf="savedFilter && savedFilter.id">({{ savedFilter.name }})</span>
  </div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form [formGroup]="filterForm">
  <!-- Subject -->
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Status</mat-label>
      <mat-select [formControlName]="'projectStageIdIn'" multiple>
        <mat-option *ngFor="let projectStage of projectStages" [value]="projectStage.id">
          {{ projectStage.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Property Type</mat-label>
      <mat-select [formControlName]="'propertyTypeIdIn'" multiple>
        <mat-option *ngFor="let propertyType of propertyTypes" [value]="propertyType.id">
          {{ propertyType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Deal Type</mat-label>
      <mat-select [formControlName]="'projectTypeIdIn'" multiple>
        <mat-option *ngFor="let projectType of projectTypes" [value]="projectType.id">
          {{ projectType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Investment Type</mat-label>
      <mat-select [formControlName]="'investmentTypeIdIn'" multiple>
        <mat-option *ngFor="let investmentType of investmentTypes" [value]="investmentType.id">
          {{ investmentType.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Vehicle</mat-label>
      <mat-select [formControlName]="'vehicleIdIn'" multiple>
        <mat-option *ngFor="let vehicle of vehicles" [value]="vehicle.id">
          {{ vehicle.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Assigned To</mat-label>
      <mat-select [formControlName]="'assignedUserIdIn'" multiple>
        <mat-option *ngFor="let user of users" [value]="user.id">
          {{ user.full_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>City</mat-label>
      <input matInput [formControlName]="'city'" />
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>State</mat-label>
      <input matInput [formControlName]="'state'" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Zip</mat-label>
      <input matInput [formControlName]="'zip'" />
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Market</mat-label>
      <input matInput [formControlName]="'marketNameCont'" />
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row">
    <mat-form-field class="flex-auto gt-xs:pr-3" *ngIf="isMapView">
      <mat-label>Created After</mat-label>
      <input
        matInput
        [matDatepicker]="createdAtGteqPicker"
        [formControlName]="'createdAtGteq'"
        [placeholder]="'Date'"
      />
      <mat-datepicker-toggle matSuffix [for]="createdAtGteqPicker"> </mat-datepicker-toggle>
      <mat-datepicker #createdAtGteqPicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="flex flex-col gt-xs:flex-row" *ngIf="!isMapView">
    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Created After</mat-label>
      <input
        matInput
        [matDatepicker]="createdAtGteqPicker"
        [formControlName]="'createdAtGteq'"
        [placeholder]="'Date'"
      />
      <mat-datepicker-toggle matSuffix [for]="createdAtGteqPicker"> </mat-datepicker-toggle>
      <mat-datepicker #createdAtGteqPicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex-auto gt-xs:pr-3">
      <mat-label>Created Before</mat-label>
      <input
        matInput
        [matDatepicker]="createdAtLteqPicker"
        [formControlName]="'createdAtLteq'"
        [placeholder]="'Date'"
      />
      <mat-datepicker-toggle matSuffix [for]="createdAtLteqPicker"> </mat-datepicker-toggle>
      <mat-datepicker #createdAtLteqPicker></mat-datepicker>
    </mat-form-field>
  </div>

  <!-- Body -->

  <div class="actions">
    <div class="formatting">
      <mat-form-field class="flex-auto gt-xs:pr-3">
        <mat-label>Save Filter As (optional):</mat-label>
        <input matInput [(ngModel)]="savedFilter.name" [ngModelOptions]="{ standalone: true }" />
      </mat-form-field>
      <button mat-icon-button *ngIf="savedFilter && savedFilter.id" class="mt-8">
        <mat-icon [svgIcon]="'delete'" (click)="deleteSavedFilter()"></mat-icon>
      </button>
    </div>
    <div class="buttons">
      <!-- Discard -->
      <button class="discard-button" mat-button type="button" (click)="discard()">
        <span>Cancel</span>
      </button>
      <!-- Send -->
      <button class="send-button" mat-flat-button type="submit" [color]="'primary'" (click)="save()">
        <span>Run</span>
      </button>
    </div>
  </div>
</form>
